<script setup>
  import { onLaunch, onShow, onError } from '@dcloudio/uni-app';
  import { ShoproInit } from './sheep';
  import AuthUtil from './sheep/api/member/auth';
  import $store from './sheep/store';
  import { setHandlingWechatCallback, setTenantId, setDistributorId } from './sheep/request/index';

  onLaunch(async () => {
    // 隐藏原生导航栏 使用自定义底部导航
    uni.hideTabBar({
      fail: () => {},
    });

    // #ifdef H5
    // 先处理URL参数，缓存 tenantId 和 distributorId
    handleUrlParams();
    // 先处理微信授权回调（在 ShoproInit 之前，避免401循环）
    await handleWechatCallback();
    // #endif

    // 加载Shopro底层依赖
    await ShoproInit();
  });

  // #ifdef H5
  // 处理URL参数（tenantId、distributorId）
  const handleUrlParams = () => {
    const url = new URL(window.location.href);
    const tenantId = url.searchParams.get('tenantId');
    const distributorId = url.searchParams.get('distributorId');

    // 缓存 tenantId
    if (tenantId) {
      setTenantId(tenantId);
    }

    // 缓存 distributorId（如果有）
    if (distributorId) {
      setDistributorId(distributorId);
    }
  };

  // 处理微信授权回调（H5环境）
  const handleWechatCallback = async () => {
    const url = new URL(window.location.href);
    const code = url.searchParams.get('code');
    const state = url.searchParams.get('state');

    if (code && state) {
      // 设置标志，表示正在处理微信回调登录
      setHandlingWechatCallback(true);

      // 清除URL中的code/state参数，避免重复处理
      url.searchParams.delete('code');
      url.searchParams.delete('state');
      window.history.replaceState({}, '', url.toString());

      // 获取分销员编号（如果有的话）
      const distributorId = uni.getStorageSync('distributor-id') || null;

      // 调用微信H5登录接口
      uni.showLoading({ title: '登录中...', mask: true });
      try {
        const loginResult = await AuthUtil.wechatH5Login(code, state, distributorId);
        uni.hideLoading();

        if (loginResult.code === 0 && loginResult.data) {
          // Token 在响应拦截器中已自动保存
          uni.showToast({ title: '登录成功', icon: 'success' });
          // 登录成功后强制刷新页面
          setTimeout(() => {
            window.location.reload();
          }, 500);
        } else {
          uni.showToast({ title: loginResult.msg || '登录失败', icon: 'none' });
        }
      } catch (e) {
        uni.hideLoading();
        uni.showToast({ title: '登录失败', icon: 'none' });
      }

      // 登录完成，重置标志
      setHandlingWechatCallback(false);
    }
  };
  // #endif

  onShow(() => {
    // #ifdef APP-PLUS
    // 获取urlSchemes参数
    const args = plus.runtime.arguments;
    if (args) {
    }

    // 获取剪贴板
    uni.getClipboardData({
      success: (res) => {},
    });
    // #endif
  });
</script>

<style lang="scss">
  @import '@/sheep/scss/index.scss';

  /* 修复原生tabBar边框定位问题 */
  uni-tabbar {
    uni-tabbar-border {
      position: static !important;
    }
  }

  /* 使用深度选择器覆盖 */
  :deep(.uni-tabbar-border) {
    position: static !important;
    display: none !important;
  }
</style>
